// tslint:disable:max-line-length

import React from 'react';

export const StatusError = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M11.31,0H4.69L0,4.69v6.62L4.69,16h6.62L16,11.31V4.69Zm1,9.36L9.13,12.22h0a2.73,2.73,0,0,1-1.84.7,2.77,2.77,0,0,1-2.77-2.77V4.77A.45.45,0,0,1,5,4.31a.46.46,0,0,1,.46.46V7.69A.31.31,0,0,0,5.75,8a.3.3,0,0,0,.3-.31V4.15a.47.47,0,0,1,.93,0V7.38a.31.31,0,0,0,.31.31.3.3,0,0,0,.3-.31V3.54a.46.46,0,0,1,.46-.46h0a.46.46,0,0,1,.47.46V7.08a.29.29,0,0,0,.3.3.3.3,0,0,0,.31-.3V4.15a.47.47,0,0,1,.46-.46.46.46,0,0,1,.46.46V8.92a.37.37,0,0,0,.62.22l.8-.65a.62.62,0,0,1,.87.87Z" />
    </svg>
  );
};
